<template>
  <div>
    <div class="row" style="margin-top: 20px">
      <div class="col-md-12 col-sm-12 text-center">
        <div class="botaoNovo">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            data-target="#dialogEdit"
            @click="itemNovo()"
          >
            Novo
          </button>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 20px">
      <div class="col col-md-8 offset-md-2 col-sm-12 text-center">
        <div class="d-flex justify-content-center">
          <Combo
            :itens="$global.sites_filtro()"
            v-model="filtroSite"
            style="max-width: 150px; margin-right: 10px"
            @change="carregarItens"
            v-if="
              retornaSite() !== '7live' &&
              retornaSite() !== 'Share' &&
              retornaSite() !== 'Stream1x2'
            "
          />

          <input
            class="form-control inputPesquisa"
            type="text"
            placeholder="Pesquise..."
            v-model="filtroTexto"
            @keyup="keyupFiltroTexto"
            style="min-width: 300px; margin-right: 10px"
            autocomplete="off"
          />

          <Combo
            :itens="[
              {
                id:
                  retornaSite() == 'Weddbets'
                    ? 'tempVencimento_ASC'
                    : 'vencimento_ASC',
                nome: 'Vencimento ASC',
              },
              {
                id:
                  retornaSite() == 'Weddbets'
                    ? 'tempVencimento_DESC'
                    : 'vencimento_DESC',
                nome: 'Vencimento DESC',
              },
              { id: 'nome_ASC', nome: 'Nome ASC' },
              { id: 'nome_DESC', nome: 'Nome DESC' },
              { id: 'email_ASC', nome: 'Email ASC' },
              { id: 'email_DESC', nome: 'Email DESC' },
              { id: 'dataCadastro_ASC', nome: 'Cadastro ASC' },
              { id: 'dataCadastro_DESC', nome: 'Cadastro DESC' },
            ]"
            v-model="ordem"
            style="max-width: 200px"
            @change="carregarItens"
            v-if="retornaSite() !== '7live'"
          />
        </div>

        <hr />

        <div
          class="row"
          style="margin-top: 20px; margin-bottom: 10px"
          v-if="retornaSite() !== '7live'"
        >
          <div class="col-md-12 col-sm-12 text-center">
            <span>
              <a
                type="button"
                class="badge badge-light"
                v-bind:class="{
                  'badge-dark': filtroTipoUsuario == 'Todos',
                  'badge-light': filtroTipoUsuario !== 'Todos',
                }"
                style="margin-left: 5px"
                @click="
                  filtroTipoUsuario = 'Todos';
                  $refs.paginacao.pagina = 1;
                  carregarItens();
                "
                >Todos</a
              >
            </span>

            <span
              v-for="tipoUsuario in $global.tipos_usuarios()"
              :key="tipoUsuario.id"
              :item="tipoUsuario"
            >
              <a
                type="button"
                class="badge badge-light"
                v-bind:class="{
                  'badge-dark': filtroTipoUsuario == tipoUsuario.id,
                  'badge-light': filtroTipoUsuario !== tipoUsuario.id,
                }"
                style="margin-left: 5px"
                @click="
                  filtroTipoUsuario = tipoUsuario.id;
                  $refs.paginacao.pagina = 1;
                  carregarItens();
                "
                >{{ tipoUsuario.nome }}</a
              >
            </span>
          </div>
        </div>

        <div class="rowLista">
          <div
            class="list-group-item list-group-item-action"
            v-for="item in itens"
            :key="item.id"
            :item="item"
          >
            <div class="row">
              <div class="col col-md-12">
                <a
                  data-toggle="modal"
                  @click="editarItem(item._id)"
                  data-target="#dialogEdit"
                  role="button"
                >
                  <div class="text-left"></div>
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1" v-if="retornaSite() !== '7live'">
                      {{ item.nome }}
                    </h5>
                    <h6
                      v-if="retornaSite() == 'Weddbets'"
                      style="margin-bottom: 0px"
                    >
                      <small
                        ><b>{{ formatDateTime(item.dataCadastro) }}</b></small
                      >
                    </h6>
                    <h5 class="mb-1" v-if="retornaSite() == '7live'">
                      {{ item.email }}
                    </h5>
                  </div>
                  <div>
                    <p
                      class="
                        text-secondary
                        textoResumo
                        d-flex
                        w-100
                        justify-content-between
                      "
                    >
                      <small v-if="retornaSite() !== '7live'"
                        >{{ item.email }}
                        <span class="text-danger"
                          ><small>{{
                            item.indicacao
                              ? "[" + item.indicacao.email + "] "
                              : ""
                          }}</small></span
                        >
                      </small>
                      <small v-if="retornaSite() == '7live'">{{
                        $global.tipos_usuarios_index()[item.tipoUsuario].nome
                      }}</small>
                      <small
                        v-if="
                          retornaSite() == 'Stream1x2' ||
                          retornaSite() == 'Share'
                        "
                        >{{
                          $global.tipos_usuarios_index()[item.tipoUsuario].nome
                        }}
                        | {{ formatDate(item.vencimento) }}</small
                      >
                      <small
                        v-if="
                          retornaSite() !== '7live' &&
                          retornaSite() !== 'Stream1x2' &&
                          retornaSite() !== 'Share'
                        "
                        >{{ item.site + " | "
                        }}{{
                          $global.tipos_usuarios_index()[item.tipoUsuario].nome
                        }}
                        |
                        {{
                          item.idx_planosUltimo
                            ? item.idx_planosCorrente
                              ? formatDate(item.idx_planosCorrente.dataFim)
                              : formatDate(item.idx_planosUltimo.dataFim)
                            : formatDate(item.vencimento)
                        }}
                        {{
                          item.idx_planosProximo &&
                          item.idx_planosProximo.length > 0
                            ? "... " +
                              formatDate(
                                item.idx_planosProximo[
                                  item.idx_planosProximo.length - 1
                                ].dataFim
                              )
                            : ""
                        }}</small
                      >
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="rowPaginacao" style="margin-top: 15px">
          <Paginacao
            ref="paginacao"
            :total="itensTotal"
            :limit="itensLimit"
            @change-pagina="carregarItens"
          />
        </div>

        <EditUsuario ref="editItem" @save-item="carregarItens" />
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import EditUsuario from "../edits/EditUsuario.vue";

import Paginacao from "../components/Paginacao.vue";
import Combo from "../components/Combo.vue";

export default {
  name: "ListUsuarios",
  components: { EditUsuario, Paginacao, Combo },
  props: { itensLimit: { type: Number, default: 50 } },
  methods: {
    retornaSite() {
      return this.$site;
    },
    async carregarItens() {
      var filtros = "";

      if (this.retornaSite() == "7live") {
        this.ordem = "email_ASC";
      }

      filtros +=
        "?_limit=" + this.itensLimit + "&_page=" + this.$refs.paginacao.pagina;

      if (this.filtroTexto !== "") {
        filtros += "&_all=" + this.filtroTexto;
      }

      if (this.filtroSite !== "Todos") {
        filtros += "&site=" + this.filtroSite;
      }

      if (this.filtroTipoUsuario !== "Todos") {
        filtros += "&tipoUsuario=" + this.filtroTipoUsuario;
      }

      filtros += "&_ordem=" + this.ordem;

      const response = await api.get("/usuario" + filtros);
      api.valid(response.data, this.$router);

      this.itens = response.data.itens;
      this.itensTotal = response.data.total;
    },
    editarItem(id) {
      this.$refs.editItem.carregarItem(id);
    },
    itemNovo() {
      this.$refs.editItem.novo();
    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      var obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        obj.$refs.paginacao.pagina = 1;
        obj.carregarItens();
      }, 300);
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    formatDateTime(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDateTime(data);
    },
  },
  mounted() {
    if (this.retornaSite() == "Weddbets") {
      this.ordem = "tempVencimento_DESC";
    }
    this.carregarItens();
  },
  data: function () {
    return {
      filtroTexto: "",
      filtroSite: "Todos",
      filtroTipoUsuario: "Todos",
      ordem: "vencimento_ASC",
      itens: [],
      itensTotal: 0,
      editItem: null,
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.inputPesquisa {
  max-width: 50%;
}

.botaoNovo {
  margin-top: 6px;
}
</style>
